import React from "react";
import { Link } from "../layouts/menus/link";
import { LayoutGrid } from "lucide-react";

type IHeaderButton = {
  bgColor: string;
  textColor: string;
  actionText: string;
  link: string;
  icon?: any;
};
interface IHeaderProps {
  title: string;
  subtitle?: any;
  buttons?: IHeaderButton[];
  img?: string;
}

const BUTTON_STYLES: Record<string, string> = {
  indigo: "bg-primary-600 text-white hover:bg-primary-700",
  green: "bg-green-600 text-white hover:bg-green-700",
  red: "bg-red-600 text-white hover:bg-red-700",
  gray: "bg-gray-600 text-white hover:bg-gray-700",
};

export const Header: React.FC<IHeaderProps> = ({
  img,
  title,
  subtitle = "",
  buttons = [],
}) => {
  return (
    <section className="px-4 py-4 sm:px-8 sm:py-5 lg:px-14 lg:py-6 bg-white dark:bg-surface-dark-alt border-b border-gray-200 dark:border-zinc-800">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="min-w-0">
            <h1 className="text-lg font-bold text-gray-900 dark:text-zinc-100 truncate">
              {title}
            </h1>
            {subtitle && (
              <p className="text-sm text-gray-500 dark:text-zinc-400 truncate">{subtitle}</p>
            )}
          </div>
        </div>

        {buttons.length > 0 && (
          <div className="flex flex-wrap items-center gap-2">
            {buttons.map((button, index) => (
              <Link key={`header-button-${index}`} to={button.link}>
                <span
                  className={`inline-flex items-center gap-2 py-2.5 px-5 text-sm font-medium rounded-md transition-colors ${
                    BUTTON_STYLES[button.bgColor] ?? BUTTON_STYLES.indigo
                  }`}
                >
                  {button.icon && (
                    <span className="inline-flex w-4 h-4">{button.icon}</span>
                  )}
                  <span>{button.actionText}</span>
                </span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
